<template>
  <el-dialog
    title="选择活动"
    :visible="visible"
    width="860px"
    :close-on-click-modal="false"
    append-to-body
    class="page-dialog activity-select-dialog"
    @update:visible="val => $emit('update:visible', val)"
    @open="handleOpen"
  >
    <div class="dialog-body">
      <el-form :inline="true" :model="searchForm" size="mini" label-width="72px" style="margin-bottom: 8px">
        <el-form-item label="活动名称">
          <el-input v-model="searchForm.title" placeholder="请输入活动名称" clearable style="width: 240px" />
        </el-form-item>
        <el-form-item label="活动类型">
          <el-select v-model="searchForm.type" placeholder="全部" clearable style="width: 180px">
            <el-option v-for="opt in ACT_TYPE_OPTIONS" :key="opt.value" :label="opt.label" :value="opt.value" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="handleSearch">搜索</el-button>
          <el-button size="mini" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table v-loading="loading" :data="list" size="small" border stripe highlight-current-row style="width: 100%">
        <el-table-column type="index" label="序号" width="60" align="center" />
        <el-table-column prop="title" label="活动名称" min-width="220" show-overflow-tooltip>
          <template slot-scope="scope">
            <LanguageInputEcho :obj="scope.row.title || {}" size="mini" />
          </template>
        </el-table-column>
        <el-table-column prop="typeLabel" label="活动类型" width="140" />
        <el-table-column label="操作" width="90" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handlePick(scope.row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div style="text-align: right; margin-top: 12px">
        <el-pagination
          :current-page="currentPage"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :page-sizes="[10, 20, 30, 50]"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { listAct } from '@/api/operation/activity'
import { ACT_TYPE_OPTIONS } from '@/pages/admin/operation/const'
import LanguageInputEcho from '@/components/LanguageInputEcho/index.vue'

export default {
  name: 'ActivitySelectDialog',
  components: {
    LanguageInputEcho,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ACT_TYPE_OPTIONS,
      searchForm: {
        title: '',
        type: '',
      },
      list: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
    }
  },
  methods: {
    handleOpen() {
      this.currentPage = 1
      this.loadList()
    },
    async loadList() {
      this.loading = true
      try {
        const params = {
          page: this.currentPage,
          page_size: this.pageSize,
        }
        if (this.searchForm.title) params.title = this.searchForm.title
        if (this.searchForm.type !== '' && this.searchForm.type != null) params.type = this.searchForm.type

        const res = await listAct(params)
        const data = (res && res.data) || res
        const rawList = (data && data.list) || []
        const rawTotal = (data && data.total) != null ? data.total : 0
        this.total = rawTotal
        this.list = Array.isArray(rawList) ? rawList.map(this.mapRow) : []
      } catch (e) {
        this.list = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    mapRow(item) {
      const typeLabel = ACT_TYPE_OPTIONS.find(opt => opt.value === item.type)?.label
      return {
        ...item,
        typeLabel: typeLabel || `类型${item.type}`,
      }
    },
    handleSearch() {
      this.currentPage = 1
      this.loadList()
    },
    handleReset() {
      this.searchForm.title = ''
      this.searchForm.type = ''
      this.currentPage = 1
      this.loadList()
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
      this.loadList()
    },
    handleCurrentChange(p) {
      this.currentPage = p
      this.loadList()
    },
    handlePick(row) {
      this.$emit('select', row)
      this.$emit('update:visible', false)
    },
  },
}
</script>

<style scoped>
.dialog-body {
  padding: 6px 0 0;
}
</style>
